import { Action, Module, VuexModule, getModule, Mutation } from 'vuex-module-decorators'
import { ILoginData, IUserInfo } from '@/@types/global'
import store from '@/store'
import { Message,MessageBox } from 'element-ui'
import router from '@/router'
import { getLoginRQ, getUserInfoRQ, validKefuRQ } from '@/api/user'
import { myMsg } from '@/service'
import { CommonModule } from './common'

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: 'User'
})
export default class User extends VuexModule {
  userInfo: IUserInfo = {
    loginName: 'wolfBerry',
    roleID: 2
  }

  @Mutation
  SET_USERINFO(data: IUserInfo) {
    this.userInfo = data
  }

  @Action
  getLogin(payload: ILoginData) {
    return new Promise((resolve, reject) => {
      getLoginRQ(payload)
        .then(() => {
          localStorage.setItem('menuId', '')
          localStorage.setItem('subMenuId', '')
          Message({
            message: '登录成功',
            type: 'success',
            duration: 2000,
            onClose: () => {
              sessionStorage.removeItem("firstLogin")
              router.push('/')
            }
          })
          this.getUserInfo().then(() => {
            CommonModule.HANDLE_INIT_MENU(true)
          })
          resolve(true)
        })
        .catch((err: any) => {
          if (err.code == 401) {
            MessageBox.prompt('请输入验证码', '提示', {
              confirmButtonText: '确定',
              inputPattern: /\w{6}/,
              inputErrorMessage: '请输入验证码'
            }).then((res: any) => {
              payload.validCode = res.value
              this.getLogin(payload)
            }).catch(() => {
              Message({
                type: 'info',
                message: '取消登录'
              });
            });

            myMsg({
              message: err.msg,
              type: 'error',
              duration: 2000
            })
          } else {
            myMsg({
              message: err.msg || '登录失败，请刷新后重试',
              type: 'error',
              duration: 2000
            })
          }
          reject()
        })
    })
  }

@Action
validKefu(payload: any) {
    return new Promise((resolve, reject) => {
        validKefuRQ(payload)
            .then((res:any) => {
                Message({
                    message: '验证成功',
                    type: 'success'
                })
                resolve(true)
            })
            .catch((err: any) => {
                myMsg({
                    message: err.msg || '验证失败',
                    type: 'error',
                    duration: 2000
                })
                reject()
            })
    })
}

  @Action
  getUserInfo() {
    return new Promise((resolve, reject) => {
      getUserInfoRQ()
        .then((res: any) => {
          const  data  = res?.data
          console.log(data);
          
          const userInfo: IUserInfo = {
            id: data.ID,
            loginName: data.LoginName,
            name: data.name,
            roleID: data.RoleID,
            roleName: data.RoleName,
            upperName: data.upperName,
            right: data.Rights
          }
          this.context.commit('SET_USERINFO', userInfo)
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          resolve(res)
        })
        .catch((err: any) => {
          console.log(err)
          reject(err)
        })
    })
  }

  @Action
  logout() {
    window.location.replace(`${process.env.VUE_APP_BASE_URL}/account/logout`)
  }
}

export const UserModule = getModule(User)
